/** Base da API Operax (sem /api no final). */
const PROD_API = 'https://api.operax.digital';

function resolveApiBase(): string {
  const raw = (import.meta.env.VITE_API_URL as string | undefined)?.trim();
  // Em produção, nunca embarcar localhost/.env.local (gera Failed to fetch no celular).
  if (import.meta.env.PROD && (!raw || /localhost|127\.0\.0\.1/i.test(raw))) {
    return PROD_API;
  }
  return (raw || PROD_API).replace(/\/$/, '');
}

export const API_BASE = resolveApiBase();

/** Em preview local, usa proxy Vite (`/api`) para evitar CORS no browser. */
function apiBaseForFetch(): string {
  if (typeof window !== 'undefined') {
    const h = window.location.hostname;
    if (h === 'localhost' || h === '127.0.0.1') return '';
  }
  return API_BASE;
}

export async function apiGet<T>(path: string): Promise<T> {
  const res = await fetch(`${apiBaseForFetch()}${path}`, {
    headers: { Accept: 'application/json' },
  });
  if (!res.ok) {
    throw new Error(`API ${res.status}: ${path}`);
  }
  return res.json() as Promise<T>;
}
